/*
 * MIRUMU Locale / Route Guard
 *
 * Japanese:
 *   /products/xxx
 *   /collections/xxx
 *
 * English:
 *   /en/products/xxx
 *   /en/collections/xxx
 */

(function () {
  'use strict';

  const LANGUAGE_KEY = 'mirumu_language_selected';

  /*
   * 言語プレフィックスを付与するMIRUMU内部ページ
   */
  const LOCALIZABLE_PATHS = [
    '/products/',
    '/collections/',
    '/pages/',
    '/blogs/',
    '/search',
    '/account',
    '/cart'
  ];

  /*
   * Cookie取得
   */
  function readCookie(name) {
    const row = document.cookie
      .split('; ')
      .find((item) => item.startsWith(name + '='));

    return row
      ? decodeURIComponent(row.split('=').slice(1).join('='))
      : null;
  }

  /*
   * 現在のShopify locale
   */
  function getCurrentLocale() {
    if (window.Shopify?.locale) {
      return String(window.Shopify.locale).toLowerCase();
    }

    return (
      document.documentElement.getAttribute('lang') || ''
    ).toLowerCase();
  }

  /*
   * 手動選択された言語を取得
   */
  function getSavedLanguage() {
    let value = null;

    try {
      value = localStorage.getItem(LANGUAGE_KEY);
    } catch (_) {}

    if (!value) {
      value = readCookie(LANGUAGE_KEY);
    }

    if (value === 'ja' || value === 'en') {
      return value;
    }

    /*
     * 以前のコードで "1" が残っている場合
     */
    if (value === '1') {
      return getCurrentLocale();
    }

    return null;
  }

  /*
   * 手動選択された言語を保存
   */
  function saveLanguage(locale) {
    if (locale !== 'ja' && locale !== 'en') {
      return;
    }

    try {
      localStorage.setItem(
        LANGUAGE_KEY,
        locale
      );
    } catch (_) {}

    document.cookie =
      LANGUAGE_KEY +
      '=' +
      locale +
      '; path=/; max-age=31536000; SameSite=Lax';
  }

  /*
   * 現在のMarket / Countryを取得
   */
  function getCountryIso() {
    const wrapper =
      document.querySelector('.header__wrapper');

    return (
      wrapper?.dataset?.countryIso || ''
    ).toUpperCase();
  }

  /*
   * 初期表示する言語を決定
   *
   * 1. ユーザーが手動選択済み → それを優先
   * 2. 未選択 → JPなら日本語
   * 3. その他 → 英語
   */
  function getDesiredLocale() {
    const saved = getSavedLanguage();

    if (saved) {
      return saved;
    }

    return getCountryIso() === 'JP'
      ? 'ja'
      : 'en';
  }

  /*
   * localeに対応するroot
   */
  function expectedRoot(locale) {
    return locale === 'en'
      ? '/en/'
      : '/';
  }

  /*
   * Shopify / theme側のrootを補正
   *
   * 例:
   * Shopify.locale = ja
   * Shopify.routes.root = /en/
   *
   * のような不整合対策
   */
  function normalizeGlobalRoutes(locale) {
    const root = expectedRoot(locale);

    if (window.Shopify?.routes) {
      try {
        window.Shopify.routes.root = root;
      } catch (_) {}
    }

    if (window.theme?.routes) {
      try {
        window.theme.routes.root = root;
      } catch (_) {}
    }
  }

  /*
   * 英語プレフィックス対象ページか
   */
  function shouldLocalizePath(pathname) {
    if (pathname === '/') {
      return true;
    }

    return LOCALIZABLE_PATHS.some(
      (prefix) =>
        pathname.startsWith(prefix)
    );
  }

  /*
   * 壊れた商品URLを正常化
   *
   * 例:
   *
   * /collections/all-products/en/products/xxx
   * ↓
   * /en/products/xxx
   *
   * /collections/all-products/products/xxx
   * ↓
   * /products/xxx
   */



  function normalizeBrokenProductPath(pathname) {
  let path = pathname;

  /*
   * English:
   * /en/collections/all-products/en/products/xxx
   * → /en/products/xxx
   */
  path = path.replace(
    /^\/en\/collections\/[^/]+\/en\/products\//,
    '/en/products/'
  );

  /*
   * English:
   * /en/collections/all-products/products/xxx
   * → /en/products/xxx
   */
  path = path.replace(
    /^\/en\/collections\/[^/]+\/products\//,
    '/en/products/'
  );

  /*
   * Japanese / broken:
   * /collections/all-products/en/products/xxx
   * → /en/products/xxx
   */
  path = path.replace(
    /^\/collections\/[^/]+\/en\/products\//,
    '/en/products/'
  );

  /*
   * Japanese:
   * /collections/all-products/products/xxx
   * → /products/xxx
   */
  path = path.replace(
    /^\/collections\/[^/]+\/products\//,
    '/products/'
  );

  return path;
}

  /*
   * URLを現在の言語に合わせる
   */
  function normalizeUrl(rawUrl, locale) {
    if (!rawUrl) {
      return rawUrl;
    }

    /*
     * 特殊リンクは変更しない
     */
    if (
      rawUrl.startsWith('#') ||
      rawUrl.startsWith('mailto:') ||
      rawUrl.startsWith('tel:') ||
      rawUrl.startsWith('javascript:')
    ) {
      return rawUrl;
    }

    try {
      const url = new URL(
        rawUrl,
        window.location.origin
      );

      /*
       * 外部URLは変更しない
       */
      if (
        url.origin !==
        window.location.origin
      ) {
        return rawUrl;
      }

      let pathname =
        normalizeBrokenProductPath(
          url.pathname
        );

      /*
       * 日本語
       */
      if (locale === 'ja') {
        if (
          pathname === '/en' ||
          pathname.startsWith('/en/')
        ) {
          pathname =
            pathname.replace(
              /^\/en(?=\/|$)/,
              ''
            ) || '/';
        }
      }

      /*
       * 英語
       */
      if (locale === 'en') {
        if (
          !pathname.startsWith('/en') &&
          shouldLocalizePath(pathname)
        ) {
          pathname =
            pathname === '/'
              ? '/en/'
              : '/en' + pathname;
        }
      }

      return (
        pathname +
        url.search +
        url.hash
      );
    } catch (_) {
      return rawUrl;
    }
  }

  /*
   * 現在存在するリンクをまとめて補正
   */
  function normalizeLinks(
    locale,
    root = document
  ) {
    root
      .querySelectorAll?.('a[href]')
      .forEach((link) => {
        normalizeSingleLink(
          link,
          locale
        );
      });
  }

  /*
   * 1リンク補正
   */
  function normalizeSingleLink(
    link,
    locale
  ) {
    if (!link) {
      return;
    }

    const href =
      link.getAttribute('href');

    if (!href) {
      return;
    }

    const normalized =
      normalizeUrl(
        href,
        locale
      );

    if (
      normalized &&
      normalized !== href
    ) {
      link.setAttribute(
        'href',
        normalized
      );
    }
  }

  /*
   * Ajax等で後から追加されるリンクを監視
   *
   * 関連商品もここで補正
   */
  function watchDynamicLinks(locale) {
    if (!document.body) {
      return;
    }

    const observer =
      new MutationObserver(
        (mutations) => {
          mutations.forEach(
            (mutation) => {

              /*
               * href自体が後から変更された場合
               */
              if (
                mutation.type ===
                  'attributes' &&
                mutation.target instanceof
                  HTMLAnchorElement
              ) {
                normalizeSingleLink(
                  mutation.target,
                  locale
                );

                return;
              }

              /*
               * AjaxでDOMが追加された場合
               */
              mutation.addedNodes.forEach(
                (node) => {
                  if (
                    !(
                      node instanceof
                      Element
                    )
                  ) {
                    return;
                  }

                  if (
                    node.matches?.(
                      'a[href]'
                    )
                  ) {
                    normalizeSingleLink(
                      node,
                      locale
                    );
                  }

                  normalizeLinks(
                    locale,
                    node
                  );
                }
              );
            }
          );
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href']
      }
    );
  }

  /*
   * クリック直前の最終安全弁
   *
   * 他のJavaScriptがhrefを書き戻した場合でも
   * ユーザーがクリックする瞬間に正常化
   */
  function registerLinkGuard(locale) {
    document.addEventListener(
      'click',
      function (event) {
        const link =
          event.target.closest?.(
            'a[href]'
          );

        if (!link) {
          return;
        }

        normalizeSingleLink(
          link,
          locale
        );
      },
      true
    );
  }

  /*
   * 現在ページを
   * 選択されたlocaleに合わせて正常化
   */
  function buildReturnTo(locale) {
    const url =
      new URL(
        window.location.href
      );

    let pathname =
      normalizeBrokenProductPath(
        url.pathname
      );

    /*
     * 一度日本語基準のURLに戻す
     */
    pathname =
      pathname.replace(
        /^\/en(?=\/|$)/,
        ''
      ) || '/';

    /*
     * 英語なら先頭に /en
     */
    if (locale === 'en') {
      pathname =
        pathname === '/'
          ? '/en/'
          : '/en' + pathname;
    }

    return (
      pathname +
      url.search +
      url.hash
    );
  }

  /*
   * Shopify Localization APIへ反映
   */
  async function setLocalization(
    locale,
    country
  ) {
    const returnTo =
      buildReturnTo(locale);

    const fd =
      new FormData();

    fd.set(
      'form_type',
      'localization'
    );

    fd.set(
      'utf8',
      '✓'
    );

    fd.set(
      'locale_code',
      locale
    );

    fd.set(
      'country_code',
      country
    );

    fd.set(
      'return_to',
      returnTo
    );

    try {
      const response =
        await fetch(
          '/localization',
          {
            method: 'POST',
            body: fd,
            credentials:
              'same-origin'
          }
        );

      if (!response.ok) {
        throw new Error(
          'Localization POST failed: ' +
          response.status
        );
      }

      window.location.replace(
        returnTo
      );
    } catch (error) {
      console.error(
        'MIRUMU localization failed:',
        error
      );
    }
  }

  /*
   * 言語セレクターで手動選択した場合に保存
   */
  function registerLanguageSelector() {
    document.addEventListener(
      'click',
      function (event) {
        const button =
          event.target.closest?.(
            '.floating-modal-parent .confirm-btn'
          );

        if (!button) {
          return;
        }

        const modal =
          button.closest(
            '.floating-modal-parent'
          );

        if (!modal) {
          return;
        }

        const selected =
          modal.querySelector(
            '.language-form input[type="radio"]:checked'
          );

        if (!selected) {
          return;
        }

        const locale =
          selected.value === 'EN'
            ? 'en'
            : 'ja';

        saveLanguage(locale);
      },
      true
    );
  }

  /*
   * 初期化
   */
  async function initialize() {
    registerLanguageSelector();

    const country =
      getCountryIso();

    const currentLocale =
      getCurrentLocale();

    const desiredLocale =
      getDesiredLocale();

    if (
      !country ||
      !desiredLocale
    ) {
      return;
    }

    /*
     * locale自体が違う場合
     *
     * 例:
     * JPなのにlocale=en
     */
    if (
      currentLocale !==
      desiredLocale
    ) {
      await setLocalization(
        desiredLocale,
        country
      );

      return;
    }

    /*
     * localeは正しいが
     * routes.rootだけおかしいケースも補正
     */
    normalizeGlobalRoutes(
      desiredLocale
    );

    /*
     * 現在表示されている全リンク
     */
    normalizeLinks(
      desiredLocale
    );

    /*
     * Ajaxで後から追加される関連商品等
     */
    watchDynamicLinks(
      desiredLocale
    );

    /*
     * クリック直前の最終補正
     */
    registerLinkGuard(
      desiredLocale
    );
  }

  /*
   * DOM構築後に開始
   */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }
})();